// extracted by mini-css-extract-plugin
export var hideEditor = "_md-2";
export var infoIcon = "_md-3";
export var label = "_md-1";
export var labelContainer = "_md-0";
export var readonlyText = "_md-4";